const formatSubFormData = (subForms, type = null) => {
  const forms = subForms?.map((subForm) => ({
    index: subForm.index,
    values: subForm.fields
      ?.filter((field) => field.field_code)
      ?.map((field) =>
        field.isRepeatable
          ? {
              field_code: field.field_code,
              field_list: field.fields?.map((repeatable) =>
                repeatable
                  ?.filter((repeatableField) => repeatableField.field_code)
                  ?.map((repeatableField) => formatField(repeatableField, type))
              ),
            }
          : formatField(field, type)
      ),
  }));

  return forms;
};

const formatField = (field, type) => {
  const data = {
    field_code: field.field_code,
  };

  if (field.field_type === "staticImage") return data;

  if (field.field_type === "image/photo") {
    if (field.type === "multiple") {
      if (type === "new_form")
        data.field_values = field.value?.length
          ? field.value?.map((value) =>
              value?.base64?.startsWith("data:image")
                ? value.base64.split(",")[1]
                : value.base64 || ""
            )
          : [];
      else {
        data.field_values = field.value?.length
          ? field.value
              ?.filter((value) => value.base64)
              ?.map((value) => {
                return value.base64.startsWith("data:image")
                  ? value.base64.split(",")[1]
                  : value.base64;
              })
          : [];

        data.field_obj_list = field.value?.length
          ? field.value
              ?.filter((value) => !value?.base64)
              ?.map((value) => {
                const newValue = {
                  created_at: value.date,
                  created_by: value.authorId,
                  created_name: value.author,
                  file_path: value.url,
                };

                return { ...newValue };
              })
          : [];
      }
    } else {
      if (type === "new_form")
        data.field_value = field.value?.length
          ? field.value?.map((value) =>
              value?.base64?.startsWith("data:image")
                ? value.base64.split(",")[1]
                : value.base64 || ""
            )[0]
          : "";
      else {
        data.field_value = field.value?.length
          ? field.value
              ?.filter((value) => value.base64)
              ?.map((value) => {
                return value.base64.startsWith("data:image")
                  ? value.base64.split(",")[1]
                  : value.base64;
              })[0]
          : "";

        data.field_obj = field.value?.length
          ? field.value
              ?.filter((value) => !value?.base64)
              ?.map((value) => {
                const newValue = {
                  created_at: value.date,
                  created_by: value.authorId,
                  created_name: value.author,
                  file_path: value.url,
                };

                return { ...newValue };
              })[0]
          : null;
      }
    }
  } else if (field.type === "checkbox") {
    data.field_values = field.value || null;
  } else if (field.field_type === "signature") {
    data.field_obj = field.value?.sign
      ? {
          name: field.value?.name,
          signature: field.value?.sign,
        }
      : field.value?.obj
      ? { file_path: field.value?.obj, name: field.value?.name }
      : null;
  } else if (field.field_type === "gps" && field.view_options !== "map_link") {
    data.field_value = `${field.value.lat},${field.value.lng}`;
  } else if (field.field_type === "title") {
    // do nothing
  } else if (field.field_type === "selection") {
    if (field.type === "multi_selection")
      data.field_values =
        typeof field.value === "object" && field.value?.length
          ? field.value.map((item) => item?.value)
          : [] || null;
    else
      data.field_value =
        typeof field.value === "object"
          ? field.value?.value
          : field.value || null;
  } else if (field.field_type === "date/time") {
    data.field_value = field.value ? String(field.value) : "";
  } else {
    data.field_value = field.value ? String(field.value) : null;
  }

  if (`field_attach` in field && field.field_attach) {
    data.field_attach = {
      note: field.field_attach?.note || "",
      image: field.field_attach?.image?.base64 || "",
      original_form_ids: field.field_attach?.original_forms
        ?.map((form) => form.original_id ?? form.id)
        ?.filter((id) => id != null),
    };
  }

  return data;
};

export default formatSubFormData;
